import { io } from "socket.io-client";
import { API_END_POINT } from "../../Api/EndPoints";

export const connectSocket = () => {
  const socket = io(API_END_POINT, {
    withCredentials: true,
    auth: {
      token: localStorage.getItem("token") || "",
    },
  });
  return {
    type: "SOCKET_CONNECTED",
    payload: socket,
  };
};

export const disconnectSocket = () => {
  return {
    type: "SOCKET_DISCONNECT",
  };
};
